import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, errMsg, fmtDate } from "@/lib/api";
import { PrintSheet, PrintRow } from "@/components/forms/PrintSheet";
import { DownloadMenu } from "@/components/forms/DownloadMenu";
import { tplPath } from "@/lib/forms";

export default function EntryPrint() {
  const { id, rowId } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/forms/templates/${id}/rows/${rowId}`).then((r) => setD(r.data)).catch((e) => setErr(errMsg(e))); }, [id, rowId]);
  if (err) return <div className="rounded-lg border border-rose-200 bg-rose-50 p-6 text-rose-700" data-testid="entry-print-error">{err}</div>;
  if (!d) return <div className="h-40 animate-pulse rounded-lg bg-slate-100" />;
  const { template: t, row: r } = d;
  return (
    <PrintSheet back={tplPath(t)} kind={t.name} title={r.data[t.fields[0]?.key] || "Entry"}
      actions={<DownloadMenu label="Download" path={`/forms/templates/${id}/rows/${rowId}/download`} filename={`${t.name} - ${r.data[t.fields[0]?.key] || "entry"}`} testid="entry-download" />}
      footer={<><span>Added {fmtDate(r.created_at)} by {r.created_by_name} · last updated {fmtDate(r.updated_at)}</span><span>Status: {r.status}</span></>}>
      {t.fields.map((f) => <PrintRow key={f.key} label={f.label} testid={`print-field-${f.key}`}>{r.data[f.key]}</PrintRow>)}
    </PrintSheet>
  );
}
